export const GET_MAIN_NAVIGATION = '/api/app/getTopNavMenu';

export const GET_FOOTER_NAVIGATION = '/api/newdashboard/footerMenu';

export const GET_GUIDED_QUEST_MAIN_NAVIGATION =
  '/api/spacewalks/app/getTopNavMenu';
